import { WorkshopCar } from '@impact/data';

import { IIndicataResponse } from '../indicata/indicata.models';
import { IEnrichedWorkshop } from '../pages/book-workshop-page/steps/book-workshop-select-shop.component';

export interface IBooking {
    regNumber?: string;
    comment?: string;
    mileage?: number;
    modelCode?: string;
    modelName?: string;
    makeCode?: string;
    makeName?: string;
    variantName?: string;
    variantCode?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    address?: string;
    zipCode?: string;
    city?: string;
    shop?: IEnrichedWorkshop;
    services?: {
        title?: string;
        price?: number;
        code?: string;
    }[];
    optionId?: string;
    delivery?: string;
    pickupData?: {
        address?: string;
        time?: string;
        zipCode?: string;
    };
    date?: string;
    timeCode?: string;
    carIndicataData?: IIndicataResponse;
    carDracarData?: WorkshopCar;
    consent?: boolean; // TODO: This is not being used anywhere?
    terms?: boolean; // TODO: This is not being used anywhere?
    rentalCar?: boolean;
    rentalCarClassName?: string;
}

export enum BookWorkshopStep {
    CarInfo,
    SelectShop,
    SelectService,
    SelectDelivery,
    SelectDate,
    UserInfo,
    Summary,
    Success,
}

export interface BookWorkshopDeliveryOptionInfoText {
    optionID: string;
    optionText: string;
}
